import globals from '../../globlas';
import { _sendWithAxios, _sendWithAxiosBlob, _sendWithAxiosProgress } from '../api';

const REACT_APP_URL_BASE_API = globals.REACT_APP_URL_BASE_API

export const getListagemBanner = async () => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}banner/listagem`, 'GET');
}
export const getListagemBannerConfig = async () => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}banner/config-listagem`, 'GET');
}
export const getBannerId = async (idBanner) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}banner/${idBanner}`, 'GET');
}
export const postBanner = async (data) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}banner`, 'POST', data);
}
export const putBannerId = async (idBanner,data) => { 
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}banner/${idBanner}`, 'PUT', data);
}
export const uploadBanner = async (file, folder = 'banner', options) => {
    const data = new FormData();
    data.append("file", file);
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}banner/upload-files/${folder}`, 'POST', data, options);
}